import React, { useContext, useState } from "react";
import { Rating, RoundedStar, Star } from "@smastrom/react-rating";
import "@smastrom/react-rating/style.css";
import { Link } from "react-router-dom";
import { RatingContext } from "./RatingContext";

const starStyle = {
  itemShapes: Star,
  activeFillColor: "#f59e0b", // amber-500
  inactiveFillColor: "#ffedd5", // amber-100
  //   inactiveFillColor: "#999ACF", // amber-100
};

export default function App() {
  //   const [rating, setRating] = useState(0);
  const { rating, updateRating } = useContext(RatingContext);

  const handleRatingChange = (newRating) => {
    updateRating(newRating);
    if (newRating >= 4) {
      window.open(
        "https://chromewebstore.google.com/detail/ihfjboopehfdmedfagockddklomdmglh/reviews",
        "_blank"
      );
    }
  };

  return (
    <div className="flex flex-col justify-center items-center mx-auto mt-5 rounded-lg shadow-lg">
      <h2 className="text-xl font-semibold mb-1 text-center">
        Rate Your Experience
      </h2>
      <Rating
        value={rating}
        onChange={handleRatingChange}
        itemStyles={starStyle}
        style={{ maxWidth: 150 }}
      />
      {/* {rating === 0 && <p className="text-gray-500">Please select a rating</p>} */}
      {rating >= 4 && (
        <p className=" font-medium  text-center">
          <span className="font-bold text-[#bdcf32]">Thank You</span> for your
          support! 🙌
        </p>
      )}
      {rating > 0 && rating < 4 && (
        <p className="text-center text-md font-normal">
          We'd love to hear your{" "}
          <Link to="/feedback" className="font-bold text-[#bdcf32]">
            <span className="inline-block transform hover:scale-110 transition-transform duration-200">
              FEEDBACK!
            </span>
          </Link>{" "}
          🙌
        </p>
      )}
    </div>
  );
}
